module.exports = __webpack_public_path__ + "img/planet-mars-geology.830f3335.png";